import React, { Component } from "react";

import FirstScreen from "./FirstScreen";
import Home from "./Home";

class Mobile extends Component {
    componentDidMount() {
        setTimeout(() => {
            if (document.getElementsByClassName("popup-content")[0]) {
                document.getElementsByClassName("popup-content")[0].style.backgroundColor = "transparent";
            }
        }, 100);
    }
    render() {
        const hasUserSetAddress = localStorage.getItem("userSetAddress") !== null;
        console.log("Mobile component render - hasUserSetAddress:", hasUserSetAddress);
        console.log("Mobile component render - userSetAddress value:", localStorage.getItem("userSetAddress"));
        
        return (
            <React.Fragment>
                {hasUserSetAddress ? (
                    <div>
                        <Home />
                    </div>
                ) : (
                    <FirstScreen languages={this.props.languages} />
                )}
            </React.Fragment>
        );
    }
}

export default Mobile;
